/**
 * @generated SignedSource<<84218edc8f298c2682672f891f49ba2c>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "after"
        },
        {
            "defaultValue": 100,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "fromDate"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "toDate"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "where"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "whereAbsences"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v2 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v3 = {
        "kind": "Variable",
        "name": "fromDate",
        "variableName": "fromDate"
    }, v4 = {
        "kind": "Variable",
        "name": "model",
        "variableName": "model"
    }, v5 = {
        "kind": "Variable",
        "name": "toDate",
        "variableName": "toDate"
    }, v6 = {
        "kind": "Variable",
        "name": "where",
        "variableName": "where"
    }, v7 = [
        (v1 /*: any*/),
        (v2 /*: any*/),
        (v4 /*: any*/),
        (v6 /*: any*/)
    ], v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    }, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "color",
        "storageKey": null
    }, v11 = [
        {
            "fields": [
                (v3 /*: any*/),
                (v5 /*: any*/)
            ],
            "kind": "ObjectValue",
            "name": "model"
        },
        {
            "kind": "Variable",
            "name": "where",
            "variableName": "whereAbsences"
        }
    ], v12 = [
        (v9 /*: any*/)
    ], v13 = {
        "kind": "InlineFragment",
        "selections": (v12 /*: any*/),
        "type": "Node",
        "abstractKey": "__isNode"
    }, v14 = {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "assignedEntity",
        "plural": false,
        "selections": [
            (v8 /*: any*/),
            {
                "kind": "InlineFragment",
                "selections": (v12 /*: any*/),
                "type": "ISchedulableEntity",
                "abstractKey": "__isISchedulableEntity"
            },
            (v13 /*: any*/)
        ],
        "storageKey": null
    }, v15 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assignmentTypeId",
        "storageKey": null
    }, v16 = {
        "alias": null,
        "args": null,
        "concreteType": "AssignmentType",
        "kind": "LinkedField",
        "name": "assignmentType",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
            },
            (v9 /*: any*/)
        ],
        "storageKey": null
    }, v17 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
    }, v18 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "end",
        "storageKey": null
    }, v19 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    }, v20 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "start",
        "storageKey": null
    }, v21 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
    }, v22 = {
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v23 = {
        "alias": null,
        "args": (v11 /*: any*/),
        "filters": [
            "where"
        ],
        "handle": "connection",
        "key": "useGetPlannedAbsences_plannedAbsences",
        "kind": "LinkedHandle",
        "name": "plannedAbsences"
    };
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "AbsenceCalendarGrid_schedulableEntitiesQuery",
            "selections": [
                {
                    "args": [
                        (v1 /*: any*/),
                        (v2 /*: any*/),
                        (v3 /*: any*/),
                        (v4 /*: any*/),
                        (v5 /*: any*/),
                        (v6 /*: any*/),
                        {
                            "kind": "Variable",
                            "name": "whereAbsences",
                            "variableName": "whereAbsences"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "AbsenceCalendarGridQuery"
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "AbsenceCalendarGrid_schedulableEntitiesQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v7 /*: any*/),
                    "concreteType": "SchedulableEntityConnection",
                    "kind": "LinkedField",
                    "name": "schedulableEntities",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "SchedulableEntityEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v8 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v9 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "displayName",
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "ISchedulableEntity",
                                            "abstractKey": "__isISchedulableEntity"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "User",
                                                    "kind": "LinkedField",
                                                    "name": "user",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "firstname",
                                                            "storageKey": null
                                                        },
                                                        (v10 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Avatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                (v9 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "storageId",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "queryTransform",
                                                                            "value": "width=68&height=68&mode=crop&scale=both"
                                                                        }
                                                                    ],
                                                                    "kind": "ScalarField",
                                                                    "name": "url",
                                                                    "storageKey": "url(queryTransform:\"width=68&height=68&mode=crop&scale=both\")"
                                                                },
                                                                {
                                                                    "alias": "imageUrl",
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "queryTransform",
                                                                            "value": "width=400&height=400&mode=crop&scale=both"
                                                                        }
                                                                    ],
                                                                    "kind": "ScalarField",
                                                                    "name": "url",
                                                                    "storageKey": "url(queryTransform:\"width=400&height=400&mode=crop&scale=both\")"
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "employeeId",
                                                            "storageKey": null
                                                        },
                                                        (v9 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": (v11 /*: any*/),
                                                    "concreteType": "PlannedAbsenceConnection",
                                                    "kind": "LinkedField",
                                                    "name": "plannedAbsences",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "PlannedAbsenceEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "PlannedAbsence",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v14 /*: any*/),
                                                                        (v15 /*: any*/),
                                                                        (v16 /*: any*/),
                                                                        (v17 /*: any*/),
                                                                        (v18 /*: any*/),
                                                                        (v9 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Event",
                                                                            "kind": "LinkedField",
                                                                            "name": "reasonEvent",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v19 /*: any*/),
                                                                                (v9 /*: any*/),
                                                                                (v10 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v20 /*: any*/),
                                                                        (v8 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v21 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v22 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v23 /*: any*/)
                                            ],
                                            "type": "SchedulableUser",
                                            "abstractKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Asset",
                                                    "kind": "LinkedField",
                                                    "name": "asset",
                                                    "plural": false,
                                                    "selections": [
                                                        (v19 /*: any*/),
                                                        (v10 /*: any*/),
                                                        (v9 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": (v11 /*: any*/),
                                                    "concreteType": "PlannedAbsenceConnection",
                                                    "kind": "LinkedField",
                                                    "name": "plannedAbsences",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "PlannedAbsenceEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "PlannedAbsence",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v14 /*: any*/),
                                                                        (v15 /*: any*/),
                                                                        (v16 /*: any*/),
                                                                        (v17 /*: any*/),
                                                                        (v18 /*: any*/),
                                                                        (v9 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Event",
                                                                            "kind": "LinkedField",
                                                                            "name": "reasonEvent",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v19 /*: any*/),
                                                                                (v9 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v20 /*: any*/),
                                                                        (v8 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v21 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v22 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v23 /*: any*/)
                                            ],
                                            "type": "SchedulableAsset",
                                            "abstractKey": null
                                        },
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isSchedulableEntity"
                                        },
                                        (v13 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                (v21 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        (v22 /*: any*/)
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": (v7 /*: any*/),
                    "filters": [],
                    "handle": "connection",
                    "key": "AbsenceCalendarGrid_schedulableEntities",
                    "kind": "LinkedHandle",
                    "name": "schedulableEntities"
                }
            ]
        },
        "params": {
            "cacheID": "6c3a249a2cc7a4828dbbefe38a959373",
            "id": null,
            "metadata": {},
            "name": "AbsenceCalendarGrid_schedulableEntitiesQuery",
            "operationKind": "query",
            "text": "query AbsenceCalendarGrid_schedulableEntitiesQuery(\n  $after: String\n  $first: Int = 100\n  $fromDate: DateTime!\n  $model: SchedulableEntitiesQueryRequestInput\n  $toDate: DateTime!\n  $where: SchedulableEntityFilterInput\n  $whereAbsences: PlannedAbsenceFilterInput\n) {\n  ...AbsenceCalendarGridQuery_12wqDu\n}\n\nfragment AbsenceCalendarGridQuery_12wqDu on Query {\n  schedulableEntities(where: $where, first: $first, after: $after, model: $model) {\n    edges {\n      node {\n        __typename\n        ... on ISchedulableEntity {\n          __isISchedulableEntity: __typename\n          id\n          displayName\n        }\n        ... on SchedulableUser {\n          user {\n            ...User\n            employeeId\n            id\n          }\n        }\n        ... on SchedulableAsset {\n          asset {\n            ...Asset\n            id\n          }\n        }\n        ...useGetPlannedAbsences_plannedAbsences_2MaVjC\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment Asset on Asset {\n  name\n  color\n}\n\nfragment User on User {\n  firstname\n  color\n  avatar {\n    id\n    storageId\n    url(queryTransform: \"width=68&height=68&mode=crop&scale=both\")\n    ...UserImageLightBox\n  }\n}\n\nfragment UserImageLightBox on Avatar {\n  imageUrl: url(queryTransform: \"width=400&height=400&mode=crop&scale=both\")\n}\n\nfragment useGetPlannedAbsences_plannedAbsences_2MaVjC on SchedulableEntity {\n  __isSchedulableEntity: __typename\n  ... on ISchedulableEntity {\n    __isISchedulableEntity: __typename\n    id\n    displayName\n  }\n  ... on SchedulableUser {\n    plannedAbsences(model: {fromDate: $fromDate, toDate: $toDate}, where: $whereAbsences) {\n      edges {\n        node {\n          assignedEntity {\n            __typename\n            ... on ISchedulableEntity {\n              __isISchedulableEntity: __typename\n              id\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n          assignmentTypeId\n          assignmentType {\n            title\n            id\n          }\n          description\n          end\n          id\n          reasonEvent {\n            name\n            id\n            color\n          }\n          start\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n  ... on SchedulableAsset {\n    plannedAbsences(model: {fromDate: $fromDate, toDate: $toDate}, where: $whereAbsences) {\n      edges {\n        node {\n          assignedEntity {\n            __typename\n            ... on ISchedulableEntity {\n              __isISchedulableEntity: __typename\n              id\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n          assignmentTypeId\n          assignmentType {\n            title\n            id\n          }\n          description\n          end\n          id\n          reasonEvent {\n            name\n            id\n          }\n          start\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "3bab04b7ae9807f88fdb29336977acb0";
export default node;
